import { RepositoryFactory } from "@/Apicall/masters/RepositoryFactory";
const IssueTrackerFile = RepositoryFactory.get("issueTracker");

export default {
    getIssueList({ commit }, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await IssueTrackerFile.getIssueList(
                    payload
                );
                resolve(data);
            } catch (error) {
                console.log(error);
                reject(error);
            }
        });
    },
    addIssueList({ commit }, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await IssueTrackerFile.addIssueList(
                    payload
                );
                resolve(data);
            } catch (error) {
                console.log(error);
                reject(error);
            }
        });
    },
    getIssueStatusList({ commit }, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await IssueTrackerFile.getIssueStatusList(
                    payload
                );
                resolve(data);
            } catch (error) {
                console.log(error);
                reject(error);
            }
        });
    },
    getIssueTypeList({ commit }, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await IssueTrackerFile.getIssueTypeList(
                    payload
                );
                resolve(data);
            } catch (error) {
                console.log(error);
                reject(error);
            }
        });
    },
    getModuleList({ commit }, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await IssueTrackerFile.getModuleList(
                    payload
                );
                resolve(data);
            } catch (error) {
                console.log(error);
                reject(error);
            }
        });
    },
    getFoundOnList({ commit }, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await IssueTrackerFile.getFoundOnList(
                    payload
                );
                resolve(data);
            } catch (error) {
                console.log(error);
                reject(error);
            }
        });
    },
    getSeverityList({ commit }, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await IssueTrackerFile.getSeverityList(
                    payload
                );
                resolve(data);
            } catch (error) {
                console.log(error);
                reject(error);
            }
        });
    },
    getPriorityList({ commit }, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await IssueTrackerFile.getPriorityList(
                    payload
                );
                resolve(data);
            } catch (error) {
                console.log(error);
                reject(error);
            }
        });
    },
    getUsersList({ commit }, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await IssueTrackerFile.getUsers(
                    payload
                );
                resolve(data);
            } catch (error) {
                console.log(error);
                reject(error);
            }
        });
    },
}